var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher, getOrgUnits, getUsers } from '@web/lib/demo/utils';
import { GEMINI_USAGE_CATEGORIES, GeminiGroupedChartViewEnum } from '@workalizer/shared/enums';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod, randomInt } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var DEMO_TEAMS = [
    { id: 1, title: 'Marketing' },
    { id: 2, title: 'Sales' },
    { id: 3, title: 'Finance' },
    { id: 4, title: 'Engineering' },
    { id: 5, title: 'Operations' },
    { id: 6, title: 'HR' },
    { id: 7, title: 'Product' },
    { id: 8, title: 'Support' }
];
var TEAM_USER_COUNT = 8;
var buildRandomCategoryCounts = function () {
    return GEMINI_USAGE_CATEGORIES.reduce(function (acc, category) {
        acc[category] = randomInt(20, 420);
        return acc;
    }, {});
};
var buildSummary = function (withTeam) {
    if (withTeam === void 0) { withTeam = false; }
    return GEMINI_USAGE_CATEGORIES.reduce(function (acc, category) {
        var count = randomInt(120, 980);
        var teamTotal = randomInt(400, 3200);
        acc[category] = __assign({ count: count, share: randomInt(8, 45), previous: getPercentageDiff(randomInt(80, 900), count) }, (withTeam && {
            teamAverage: getPercentageDiff(calculateAverage(teamTotal, TEAM_USER_COUNT), count)
        }));
        return acc;
    }, {});
};
export var geminiActionBreakdown = function (input) {
    if (input.userId) {
        var interval = getInterval(input.dateFrom, input.dateTo);
        var dateFrom = startOfDay(input.dateFrom);
        var dateTo = endOfDay(input.dateTo);
        var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
        var periods = groupByPeriod([], dateFrom, dateTo, interval);
        var previousPeriods_1 = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
        var periodMatcher_1 = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods_1);
        return {
            view: GeminiGroupedChartViewEnum.PERIOD,
            summary: buildSummary(true),
            segments: periods.map(function (period, index) {
                var _a;
                var previousPeriod = periodMatcher_1.getItem(index, previousPeriods_1);
                return {
                    id: period.date,
                    name: period.date,
                    period: period.date,
                    previousPeriodLabel: (_a = previousPeriod === null || previousPeriod === void 0 ? void 0 : previousPeriod.date) !== null && _a !== void 0 ? _a : '',
                    current: buildRandomCategoryCounts(),
                    previous: buildRandomCategoryCounts(),
                    team: buildRandomCategoryCounts()
                };
            })
        };
    }
    if (input.orgUnitId) {
        var users = getUsers({
            userId: null,
            orgUnitId: input.orgUnitId
        }).slice(0, 8);
        return {
            view: GeminiGroupedChartViewEnum.USER,
            summary: buildSummary(),
            segments: users.map(function (user) { return ({
                id: String(user.id),
                name: user.name || user.email,
                current: buildRandomCategoryCounts(),
                previous: buildRandomCategoryCounts()
            }); })
        };
    }
    var orgUnits = getOrgUnits({ orgUnitId: null });
    var segmentOrgUnits = orgUnits.length ? orgUnits : DEMO_TEAMS;
    return {
        view: GeminiGroupedChartViewEnum.TEAM,
        summary: buildSummary(),
        segments: segmentOrgUnits.map(function (orgUnit) { return ({
            id: String(orgUnit.id),
            name: orgUnit.title,
            current: buildRandomCategoryCounts(),
            previous: buildRandomCategoryCounts()
        }); })
    };
};
